import { render, staticRenderFns } from "./PickupPoints.vue?vue&type=template&id=5a3e1e1b&scoped=true&"
import script from "./PickupPoints.vue?vue&type=script&lang=js&"
export * from "./PickupPoints.vue?vue&type=script&lang=js&"
import style0 from "./PickupPoints.vue?vue&type=style&index=0&id=5a3e1e1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3e1e1b",
  null
  
)

export default component.exports